/* @flow */
import * as React from 'react';
import glamorous from 'glamorous';

type Props = {
  src: string,
};

const StyledImg = glamorous.img({
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
});

const Wrapper = glamorous.div({
  width: '3em',
  height: '2em',
});

function TicketIndicator({ src }: Props) {
  return (
    <Wrapper>
      <StyledImg src={src} alt="" />
    </Wrapper>
  );
}

export default TicketIndicator;
